import * as React from 'react';
import * as style from './BulkUploadWizardError.styl';

import { IUpdateDiff } from '@Shared/bulk_upload';

interface IBulkUploadWizardErrorProps {
  errorType: 'FILE' | 'INLINE';
  errorDiffs: IUpdateDiff[];
  errorMessage: string;
}

export class BulkUploadWizardError extends React.Component<IBulkUploadWizardErrorProps> {
  constructor(props: IBulkUploadWizardErrorProps) {
    super(props);
  }

  render() {
    const { errorType, errorMessage } = this.props;

    let subMessage;
    switch (errorType) {
      case 'FILE': {
        subMessage = <p>Please review the errors and make necessary changes.</p>;
        break;
      }
      case 'INLINE': {
        const count = this.props.errorDiffs.reduce<number>((errorCount, diff) => errorCount + Object.keys(diff.fieldErrorMap).length, 0);
        subMessage = (
          <p>
            Please review these <em>{count} errors</em> and make necessary changes.
          </p>
        );
        break;
      }
    }
    const errorBody = (
      <div className="errorBody">
        <p>{errorMessage}</p>
        {subMessage}
      </div>
    );

    return (
      <div className={style.global}>
        <img src={require('./file_upload_error.svg')} className="placeholderGraphic" />
        <div className="errorTitle">Failed to process file</div>
        {errorBody}
      </div>
    );
  }
}
